/**
 * Created by Abner Sui on 07/09/2020.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Component, OnInit, Input } from '@angular/core';
import { ProcessInstance, Comment } from '../../../tamalelibs/models/workflow.model';
import { EntityBrief } from '../../../tamalelibs/models/entity-brief.model';
import { WorkflowService } from '../../../tamalelibs/services/workflow.service';
import { UtilsService } from '../../../tamalelibs/services/utils.service';

@Component({
    selector: 'tam-instance-comments',
    templateUrl: './instance-comments.component.html',
    styleUrls: ['./instance-comments.component.scss']
})
export class InstanceCommentsComponent implements OnInit {

    @Input()
    instance: ProcessInstance;

    comments: Array<Comment> = [];

    constructor(
        private _utils: UtilsService,
        private _workflowService: WorkflowService,
    ) { }

    ngOnInit() {
        this.instance.task.forEach(item => {
            this.comments.push(...item.comments);
        });
        this.instance.processInstanceEvent.forEach(e => {
            e.detail.forEach(item => {
                this.comments.push(...item.comments);
            });
        });
        this.comments.sort((a, b) => a.submittedDate.getTime() - b.submittedDate.getTime());
    }

    getAbbrName(assignee: EntityBrief): string {
        return this._workflowService.getAbbrNameForOneEntity(assignee);
    }

    getBackgroundColorById(id: string): string {
        return this._utils.getBackgroundColorById(id);
    }

    onClickUser(event, submitter: EntityBrief) {
        window.open('contact/' + submitter.id, '_blank');
    }

}
